import axios from 'axios'
import * as types from '@/store/mutations'
import router from '@/router/'
import store from '@/store/'

const authModel = {
  // auth status
  is_auth: false,

  // email validation status
  is_mail_verified: false,

  // social networks status
  is_fb_connected: null,
  is_ig_connected: null,
  is_ig_businesss: null,

  // account status
  is_suspended: false,
  is_onboarding: false,
  is_billing: false,
  is_subscribed: false,
  is_subscription_cancelled: false,
  is_suspended_flag: false,

  // feature flags (available on both auth and unauth screens via pl_user_data)
  facebook_auth_enabled: false,

  // used by page-visibility.js in /src/plugins/
  timestamp: new Date(),
}

// state
export const state = {
  ...authModel,
}

// getters
export const getters = {
  is_auth: (state) => state.is_auth,

  is_mail_verified: (state) => state.is_mail_verified,

  is_fb_connected: (state) => state.is_fb_connected,
  is_ads_account: (state) => state.is_ads_account,
  is_ig_businesss: (state) => state.is_ig_businesss,

  is_suspended: (state) => state.is_suspended,
  is_onboarding: (state) => state.is_onboarding,
  is_billing: (state) => state.is_billing,
  is_subscribed: (state) => state.is_subscribed,
  is_subscription_cancelled: (state) => state.is_subscription_cancelled,
  is_suspended_flag: (state) => state.is_suspended_flag,

  facebook_auth_enabled: (state) => state.facebook_auth_enabled,
}

// mutations
export const mutations = {
  INIT(state, data) {
    state.is_auth = data.is_auth

    state.is_mail_verified = data.email_verified_at || false

    state.is_fb_connected = data.is_facebook
    state.is_ads_account = data.is_ads_account
    state.is_ig_businesss = data.is_business

    state.is_suspended = data.is_suspended
    state.is_suspended_flag = data.is_suspended_flag
    state.is_onboarding = data.is_onboarding
    state.is_billing = data.is_billing
    state.is_subscribed = data.is_subscribed
    state.is_subscription_cancelled = data.subscription_cancelled

    state.facebook_auth_enabled = data.facebook_auth_enabled !== undefined ? data.facebook_auth_enabled : false
  },

  // cleanup/reset module state. used at logout
  RESET(state) {
    Object.keys(state).forEach((key) => {
      state[key] = authModel[key]
    })
    store.dispatch('CANCEL_PENDING_REQUESTS')
    if (router.currentRoute.name !== 'login') {
      router.push({ name: 'login' })
    }
  },
  [types.AUTH_TIMESTAMP](state) {
    state.timestamp = new Date()
  },
  [types.AUTH_FB](state) {
    state.is_fb_connected = true
  },
  [types.AUTH_ADS_ACCOUNT](state) {
    state.is_ads_account = true
  },
  [types.AUTH_IG_BUSINESS](state) {
    state.is_ig_businesss = true
  },
  [types.AUTH_IS_SUBSCRIBED](state) {
    state.is_subscribed = true
    state.is_onboarding = false
  },
  [types.AUTH_IS_MAIL_CONFIRMED](state) {
    state.is_mail_verified = new Date()
  },
}

// actions
export const actions = {
  // login
  [types.LOGIN]({ dispatch }, user) {
    dispatch('INIT_STORE_DATA', user, { root: true })
  },

  // logout
  async [types.LOGOUT]({ dispatch }) {
    try {
      await axios.get('/api/auth/logout')
    } catch (e) {
      console.warn(e.message)
    }
    store.dispatch('CANCEL_PENDING_REQUESTS')
    dispatch('RESET_STORE_DATA', {}, { root: true })
  },

  // used by page-visibility.js in /src/plugins/
  async [types.AUTH_REFRESH]({ dispatch }) {
    try {
      const { data } = await axios.get('/api/auth/refresh')

      if (!data.user_data) throw new Error('No data')
      if (!data.user_data.is_auth) throw new Error('User is not authenticated')

      dispatch('INIT_STORE_DATA', data.user_data, { root: true })
    } catch (e) {
      dispatch('RESET_STORE_DATA', {}, { root: true })
    }
  },
}
